import { OTA_PricedCoverage } from "./ota_pricedcoverage.model";
import { OTA_ArrivalDetails } from "./ota_arrivaldetails.model";
import { OTA_PricedOffLocService } from "./ota_pricedofflocservice.model";

export class OTA_VehSegmentInfo {
    public arrivalDetails = new OTA_ArrivalDetails();
    public pricedCoverages = new Array<OTA_PricedCoverage>();
    public pricedOffLocServices = new Array<OTA_PricedOffLocService>();
}